import React, { useEffect } from "react";
import styles from "../../BorrowerDetails.module.css";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";

import { url } from "../../../../../App";
import axios from "axios";
import Cookies from 'js-cookie';
import { toast } from "react-toastify";
import { useBorrowerContext } from "../../store/borrower-details";

const AddressDetailsModal = ({ fetchedBorrowerDetails, closeAddressModal }) => {
  // console.log(fetchedBorrowerDetails)
  const EMAIL = Cookies.get('Email');
  const TOKEN = Cookies.get('Token');

  const [editBtnDisabled, setEditBtnDisabled] = useState(true);
  const [saveBtnDisabled, setSaveBtnDisabled] = useState(true);
  const [showFieldset, setShowFieldset] = useState(false);
  const [isEditableCurrAdd, setIsEditableCurrAdd] = useState(false);
  const [editableDetails, setEditableDetails] = useState({
    currAdd: fetchedBorrowerDetails.borrower_current_address,
    currPin: fetchedBorrowerDetails.borrower_current_pincode,
    currState: fetchedBorrowerDetails.borrower_current_state,
    currCity: fetchedBorrowerDetails.borrower_current_city,
    currSubDist: fetchedBorrowerDetails.borrower_current_subDistrict,
    currLocality: fetchedBorrowerDetails.borrower_current_locality,
    currLandMark: fetchedBorrowerDetails.borrower_current_landmark
  });
  const [subDistricts, setSubDistricts] = useState([]);
  const [localities, setLocalities] = useState([]);
  const [borrowerOtp, setBorrowerOtp] = useState("");
  const { fetchData } = useBorrowerContext();
  const [editPermission, setEditPermission] = useState(false);

  let borrower_mobile = fetchedBorrowerDetails.borrower_mobile;
  let borrower_id = fetchedBorrowerDetails.borrower_uniqueno;

  useEffect(() => {
    const checkRole = async () => {
      if (EMAIL === "rupesh.bishnoi@credin.in") {
        setEditPermission(true);
      } else {
        let role = await axios.post(url + "/user/getsingle", {
          token: TOKEN,
          email: EMAIL,
          useremail: EMAIL
        })
        console.log(role?.data);
        if (role.data[0]?.permission?.update_borrower_details === true) {
          setEditPermission(true);
        }
      }
    }
    checkRole();
  },[TOKEN,EMAIL])

  const toggleFieldsetPermAdd = () => {
    setShowFieldset((prevShowFieldset) => !prevShowFieldset);
  };

  const handleOtp = async () => {
    const sendOtp = await axios.post(url + "/user/lms/otp/send", {
      templateId: "66629e65d6fc051d3e128092",
      email: EMAIL,
      token: TOKEN,
      borrowerMobile: borrower_mobile,
      VAR1: fetchedBorrowerDetails.borrower_firstname,
      VAR2: 'Address'
    })

    console.log(sendOtp.data);
    if (sendOtp.data.type === "success") {
      toast.success("OTP Sent to +91 " + borrower_mobile);
      setTimeout(() => {
        const otp = prompt("Please Enter OTP received at +91 " + borrower_mobile);
        handleVerify(otp, borrower_mobile);
        setBorrowerOtp(otp);
        console.log(borrowerOtp);
      }, 4000);
    } else {
      console.log((sendOtp.data))
      toast.error(sendOtp.data.type);
      return;
    }
    
  }

  const handleVerify = async (otp, phone) => {
    const verify = await axios.post(url + "/user/lms/otp/verify", {
      borrowerOtp: otp,
      borrowerMobile: phone,
      email: EMAIL,
      token: TOKEN,
    })

    console.log(verify);
    if (verify.data.type === "success") {
      toast.success("OTP Verification Successful");
      setEditBtnDisabled(false);
      setSaveBtnDisabled(false);
    } else {
      toast.error("Invalid OTP Please Try Again");
      return;
    }
  }

  const handleEditCurrAdd = async () => {
    console.log('2');
    setIsEditableCurrAdd(true);
  }

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setEditableDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));

    if (name === 'currPin' & value.length === 6) {
      fetchPincodeDetails(value);
    }
  };

  const fetchPincodeDetails = async (pincode) => {
    try {

      const pinDetails = await axios.get(url + `/pincode/${pincode}`, {
        headers: {
          token: TOKEN, email: EMAIL
        }
      });
      if (pinDetails.data.Status === 'Success' && pinDetails.data.negativeArea === false) {
        if (pinDetails.data.District && pinDetails.data.State) {
          console.log('reached');
          console.log(pinDetails.data.District);
          setEditableDetails((prevDetails) => ({
            ...prevDetails,
            currCity: pinDetails.data.District,
            currState: pinDetails.data.State,
          }));
        }

        if (pinDetails.data.subDistricts.length > 0) {
          setSubDistricts(pinDetails.data.subDistricts);
          setEditableDetails((prevDetails) => ({
            ...prevDetails,
            currSubDist: pinDetails.data.subDistricts[0] 
          }));
          await fetchLocalityDetails(pinDetails.data.subDistricts[0], pincode);
        }

      }
    } catch (error) {
      console.error('Error fetching city and state:', error);
    }
  };

  const handleSubDistrictChange = async (event) => {
    const { value } = event.target;
    setEditableDetails((prevDetails) => ({
      ...prevDetails,
      currSubDist: value,
    }));
    await fetchLocalityDetails(value, editableDetails.currPin);
  };

  const fetchLocalityDetails = async (subDistrict, pincode) => {
    try {
      const localityDetails = await axios.get(url + `/pincode/${pincode}/${subDistrict}`, {
        headers: {
          token: TOKEN, email: EMAIL
        }
      });
      if (localityDetails.data.Status === 'Success') {
        setLocalities(localityDetails.data.locality);
        setEditableDetails((prevDetails) => ({
          ...prevDetails,
          currLocality: localityDetails.data.locality[0] // Set the first locality as default
        }));
      }
    } catch (error) {
      console.error('Error fetching locality:', error);
    }
  };

  const handleLocalityChange = (event) => {
    const { value } = event.target;
    setEditableDetails((prevDetails) => ({
      ...prevDetails,
      currLocality: value,
    }));
  };

  const handleSubmitCurrAdd = async () => {
    console.log('3');
    const submitUpdatedAdd = await axios.patch(url + "/borrower/edit/currentaddress", {
      token: TOKEN,
      email: EMAIL,
      borrowerId: borrower_id,
      updatedField: editableDetails,
    })
    console.log(submitUpdatedAdd.data);
    if (submitUpdatedAdd.data.auth === true) {
      toast.success('Address updated');
      setIsEditableCurrAdd(false);
      setEditBtnDisabled(true);
      setSaveBtnDisabled(true);
      fetchData();
    } else {
      toast.error(submitUpdatedAdd.data.message);
    }
  }

  return (
    <>
      <div className={styles.addressModal}>
        <div
          className={styles.addressModaOverlay}
          onClick={(e) => e.target === e.currentTarget && closeAddressModal()}
        >
          <div className={styles.addressModalContent}>
            <h2>Address Details</h2>
            <div>
              <h3>Permanent Address</h3>
              <div>
                <p>Address</p>
                <p>{fetchedBorrowerDetails.borrower_permanent_address}</p>
              </div>
              <div className={styles.pincodeDiv}>
                <div>
                  <p>Pin Code</p>
                  <p>{fetchedBorrowerDetails.borrower_permanent_pincode}</p>
                </div>
                <div>
                  <p>State Name</p>
                  <p>{fetchedBorrowerDetails.borrower_permanent_state}</p>
                </div>
                <div>
                  <p>City Name</p>
                  <p>{fetchedBorrowerDetails.borrower_permanent_city}</p>
                </div>
                <div>
                  <p>Sub District</p>
                  <p>{fetchedBorrowerDetails.borrower_permanent_subDistrict}</p>
                </div>
                <div>
                  <p>Locality/Village</p>
                  <p>{fetchedBorrowerDetails.borrower_permanent_locality}</p>
                </div>
                <div>
                  <p>Landmark</p>
                  <p>{fetchedBorrowerDetails.borrower_permanent_landmark}</p>
                </div>
              </div>
            </div>
            <div>
              <p>
                <h3>Current Address
                  {editPermission && (<button onClick={toggleFieldsetPermAdd} style={{ marginLeft: "15px", background: 'none', border: 'none', color: 'blue', cursor: 'pointer', padding: 0 }}>(Update)</button>)}
                </h3>
              </p>
              <div>
                <p>Address</p>
                {/* <p>{fetchedBorrowerDetails.borrower_current_address}</p> */}
                {isEditableCurrAdd ? (
                  <div className={styles.editableContainer}>
                    <input type="text" name="currAdd" style={{ width: '300px'}} value={editableDetails.currAdd} onChange={handleInputChange} />
                  </div>
                ) : (
                  <p>{fetchedBorrowerDetails.borrower_current_address}</p>
                )}
              </div>
              <div className={styles.pincodeDiv}>
                <div>
                  <p>Pin Code</p>
                  {isEditableCurrAdd ? (
                    <div className={styles.editableContainer}>
                      <input type="number" name="currPin" style={{ width: '50px' }} value={editableDetails.currPin} onChange={handleInputChange} />
                    </div>
                  ) : (
                    <p>{fetchedBorrowerDetails.borrower_current_pincode}</p>
                  )}
                </div>
                <div>
                  <p>State Name</p>
                  {isEditableCurrAdd ? (
                    <p>{editableDetails.currState}</p>
                  ) : (
                    <p>{fetchedBorrowerDetails.borrower_current_state}</p>
                  )}
                </div>
                <div>
                  <p>City Name</p>
                  {isEditableCurrAdd ? (
                     <p>{editableDetails.currCity}</p>
                  ) : (
                    <p>{fetchedBorrowerDetails.borrower_current_city}</p>
                  )}
                </div>
                <div>
                  <p>Sub District</p>
                  {/* <p>{fetchedBorrowerDetails.borrower_current_subDistrict}</p> */}
                  {isEditableCurrAdd ? (
                    subDistricts.length > 1 ? (
                      <select
                        name="currSubDist"
                        value={editableDetails.currSubDist}
                        onChange={handleSubDistrictChange}
                      >
                        {subDistricts.map((subDist, index) => (
                          <option key={index} value={subDist}>
                            {subDist}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <p>{editableDetails.currSubDist}</p>
                    )
                  ) : (
                    <p>{fetchedBorrowerDetails.borrower_current_subDistrict}</p>
                  )}
                </div>
                <div>
                  <p>Locality/Village</p>
                  {/* <p>{fetchedBorrowerDetails.borrower_current_locality}</p> */}
                  {isEditableCurrAdd ? (
                    localities.length > 1 ? (
                      <select
                        name="currLocality"
                        value={editableDetails.currLocality}
                        onChange={handleLocalityChange}
                      >
                        {localities.map((locality, index) => (
                          <option key={index} value={locality}>
                            {locality}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <p>{editableDetails.currLocality}</p>
                    )
                  ) : (
                    <p>{fetchedBorrowerDetails.borrower_current_locality}</p>
                  )}
                </div>
                <div>
                  <p>Landmark</p>
                  {/* <p>{fetchedBorrowerDetails.borrower_current_landmark}</p> */}
                  {isEditableCurrAdd ? (
                    <div className={styles.editableContainer}>
                      <input type="text" name="currLandMark" style={{ width: '50px' }} value={editableDetails.currLandMark} onChange={handleInputChange} />
                    </div>
                  ) : (
                    <p>{fetchedBorrowerDetails.borrower_current_landmark}</p>
                  )}
                </div>
              </div>
            </div>
            <div>
              <p>Residing at Current Address Since</p>
              <p>{fetchedBorrowerDetails.borrower_residing_since}</p>
            </div>

            {showFieldset && (
            <section>
              <fieldset className={styles.boxAddress}>
                <legend>Edit Current Address</legend>
                <div className={styles.main}>
                  <button className={styles.uploadBtn} onClick={handleOtp}>
                    Send OTP
                  </button>
                  <button className={styles.editBtn} disabled={editBtnDisabled} onClick={handleEditCurrAdd}>
                    Edit
                  </button>
                  <button className={styles.saveBtn} disabled={saveBtnDisabled} onClick={handleSubmitCurrAdd}>
                    Save
                  </button>
                </div>
              </fieldset>
            </section>
          )}

            <CloseIcon
              className={styles.CloseIcon}
              onClick={closeAddressModal}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AddressDetailsModal;
